const translations = {
  en: {
    navigationTranslate: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      team: 'Team',
      faq: 'FAQ',
      resources: 'Resources',
      contact: 'Contact',
    },
    homeTranslate: {
      lang: 'Language',
      homeEntryTitle: "It's all in the details",
      homeEntrySubtitle: 'For more than 35 years',
      homeAboutTitle: 'Your family office',
      homeAboutBody:
        "This is a temporary description that will ultimately be replaced by the client's content.",
      homeAboutRouterLink: 'Read more',
      homeEmployeeHighlightTitle:
        'C’est avec grand plaisir que nous vous informons de la venue de Maître Nathalène Chapuis au sein de notre équipe.',
      homeEmployeeHighlightBody:
        'Me Nathalène Chapuis, originaire de France, est issue d’une famille de notaires dont les premiers actes ont été reçus au 17 ème siècle par son ancêtre, Maître Cirgue Segret. Elle s’est donc naturellement orientée vers cette profession et elle obtient, en 2000, le Diplôme Supérieur du Notariat en France. Me Chapuis travaille ensuite dans deux Études notariales en France puis dans un cabinet d’avocats à Chicago avant de s’installer au Québec où elle obtient en 2006 le Diplôme de Droit Notarial. Compte tenu de sa double diplomation notariale franco-québécoise, elle s’est progressivement spécialisée auprès d’une clientèle internationale, et notamment française, dont les besoins juridiques impliquent une connaissance poussée en droit international privé. Elle a également développé, de façon plus générale, une expertise en droit successoral et droit matrimonial. Elle s’est vu confier par la Chambre des Notaires du Québec la formation en droit international privé des notaires du très prisé service 1-800-NOTAIRE. Elle participe régulièrement à des évènements auprès d’étudiants en droit du Québec à titre d’ambassadrice de la Chambre des Notaires du Québec. Maître Chapuis a également reçu à Québec le 15 mars 2019 la Convention De Coopération Entre Les Notaires De France et Du Québec signée par le Conseil supérieur du notariat (France) et la Chambre des notaires du Québec en présence de la consule générale de France. Cette convention de coopération notariale de 2019 a pour but de favoriser la coopération entre les notaires de France et du Québec au bénéfice des citoyens.',
      homeEmployeeHighlightBodySecondary:
        'Outre les nombreuses conférences auxquelles elle participe depuis plusieurs années auprès de banquiers, de planificateurs financiers et d’associations franco-canadiennes telle que l’Union de Français à l’Étranger de Montréal, Maître Chapuis a donné, en octobre 2019, une conférence auprès des notaires sur les aspects civils d’une planification patrimoniale transfrontalière. Elle travaille en étroite collaboration avec un important réseau de juristes en Europe et au Canada. Maître Chapuis privilégie toujours un travail d’équipe avec tous les professionnels impliqués au dossier.',
      homeEmployeeHighlightRouterLink: 'Lire davantage',
      homeServicesTitle: 'Our services',
      homeServicesSubtitle:
        'Nous offrons une gamme complète de services selon vos besoins',
      homeServicesService1: 'Service 1',
      homeServicesService2: 'Service 2',
      homeServicesService3: 'Service 3',
      homeServicesService4: 'Service 4',
      homeServicesService5: 'Service 5',
      homeServicesService6: 'Service 6',
      homeServicesRouterLink: 'Read More',
      homeTeamTitle: 'Our family',
      homeTeamProfileLink: 'View this profile',
      homeTeamProfilesLink: 'Read more',
      homeTeamProfile1: {
        name: 'Louise Giguère',
        title: 'Notaire',
      },
      homeTeamProfile2: {
        name: 'Louis-Philippe Leveille',
        title: 'Notaire',
      },
      homeTeamProfile3: {
        name: 'Selma Tria',
        title: 'Notaire',
      },
      homeTeamProfile4: {
        name: 'Nathalène Chapuis',
        title: 'Notaire',
      },
      motto: 'Competence, Integrity, Fidelity',
    },
    aboutTranslate: {
      aboutEntryTitle: 'Our Mission',
      aboutEntrySubtitle:
        '- EN - Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia aspernatur harum libero esse molestias obcaecati corporis accusantium eos ex hic, odio numquam, cumque non ad minus recusandae provident nisi. Doloribus recusandae explicabo veniam blanditiis totam quis ullam reiciendis numquam maxime ipsum ducimus dolores suscipit est quisquam, minima voluptatibus fuga quasi?',
      aboutEntrySubtitleSecond:
        'Ces dernières années, Me Selma Tria, notaire et Me Louis-Philippe Léveillé, notaire et fils de Me Giguère, se joignent à l’étude y apportant un vent de jeunesse. Ces derniers bénéficient alors du savoir et de l’expertise transmis par la fondatrice, ce qui leur permet de développer leur pratique basée sur les mêmes valeurs. Aujourd’hui, c’est toute l’équipe de GIGUÈRE, LÉVEILLÉ, TRIA, NOTAIRES qui exerce les activités de la société en harmonie avec les valeurs instaurées par Me Giguère tout en gardant constamment à jour leurs connaissances.',
      aboutEntryAnchorToFirstSection: 'Mission',
      aboutEntryAnchorToSecondSection: 'History',
      aboutHistoryTitle: 'Our History',
      aboutHistorySubtitle: '35 years of expertise',
      aboutHistoryBody:
        '- EN - Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia aspernatur harum libero esse molestias obcaecati corporis accusantium eos ex hic, odio numquam, cumque non ad minus recusandae provident nisi. Doloribus recusandae explicabo veniam blanditiis totam quis ullam reiciendis numquam maxime ipsum ducimus dolores suscipit est quisquam, minima voluptatibus fuga quasi?',
      aboutNextPageLinkToNextPage: 'Consult our services',
    },
    servicesTranslate: {
      servicesEntryTitle: 'Our services',
      servicesEntryAnchorToService1: 'Service 1',
      servicesEntryAnchorToService2: 'Service 2',
      servicesEntryAnchorToService3: 'Service 3',
      servicesEntryAnchorToService4: 'Service 4',
      servicesEntryAnchorToService5: 'Service 5',
      servicesEntryAnchorToService6: 'Service 6',
      servicesService1: {
        title: 'Immobilier',
        subtitle: 'La sécurité avant tout.',
        linkDesktop: 'Renseignez-vous auprès de nos notaires',
        step1: {
          title: 'Déclaration de transmission.',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step2: {
          title: 'Promesse d’achat',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step3: {
          title: 'Financement immobilier résidentiel et commercial',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step4: {
          title: 'Acquisition et vente d’immeuble',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step5: {
          title: 'Hypothèque mobilière',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step6: {
          title: 'Servitude',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step7: {
          title: 'Quittance',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step8: {
          title: 'Acte de donation',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
      },
      servicesService2: {
        title: 'Service 2',
        subtitle:
          'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam',
        linkDesktop: 'Consult with a member of our team',
        step1: {
          title: 'Step 1',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Click to view the full services description',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut',
        },
        step2: {
          title: 'Step 2',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Click to view the full services description',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut',
        },
        step3: {
          title: 'Step 3',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Click to view the full services description',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut',
        },
      },
      servicesService3: {
        title: 'Service 6',
        subtitle:
          'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam',
        linkDesktop: 'Consult with a member of our team',
        step1: {
          title: 'Step 1',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Click to view the full services description',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut',
        },
        step2: {
          title: 'Step 2',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Click to view the full services description',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut',
        },
        step3: {
          title: 'Step 3',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Click to view the full services description',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut',
        },
      },
      servicesService4: {
        title: 'Service 4',
        subtitle:
          'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam',
        linkDesktop: 'Consult with a member of our team',
        step1: {
          title: 'Step 1',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Click to view the full services description',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut',
        },
        step2: {
          title: 'Step 2',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Click to view the full services description',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut',
        },
        step3: {
          title: 'Step 3',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Click to view the full services description',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut',
        },
      },
      servicesService5: {
        title: 'Succession',
        subtitle: 'Laissez nous vous guider',
        linkDesktop: 'Renseignez-vous auprès de nos notaires',
        step1: {
          title: 'Recherche testamentaire',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step2: {
          title: 'Bilan patrimonial',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step3: {
          title: 'Déclaration de transmission',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step4: {
          title: 'Procès-verbal d’ouverture de coffret de sûreté',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
      },
      servicesService6: {
        title: 'Service 6',
        subtitle:
          'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam',
        linkDesktop: 'Consult with a member of our team',
        step1: {
          title: 'Step 1',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Click to view the full services description',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut',
        },
        step2: {
          title: 'Step 2',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Click to view the full services description',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut',
        },
        step3: {
          title: 'Step 3',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Click to view the full services description',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut',
        },
      },
      servicesNextPageLinkToNextPage: 'Our team',
    },
    teamTranslate: {
      teamEntryTitle: 'Our team',
      teamEntryAnchorToTeamMember1: 'Louise Giguère',
      teamEntryAnchorToTeamMember2: 'Louis-Philippe Léveillé',
      teamEntryAnchorToTeamMember3: 'Selma Tria',
      teamEntryAnchorToTeamMember4: 'Nathalène Chapuis',
      teamProfiles: {
        profile1: {
          name: 'Louise Giguère',
          excerpt: 'Notaire en Succession et grand montagnard',
          body:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore',
          contact: '',
        },
        profile2: {
          name: 'Louis-Philippe Léveillé',
          excerpt: 'Notaire fiscaliste et fan de course automobile',
          body:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore',
          contact: 'Communiquez avec Mr Léveillé',
        },
        profile3: {
          name: 'Selma Tria',
          excerpt: 'Notaire généraliste et joueuse de tennis passionnée',
          body:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore',
          contact: 'Communiquez avec Mme Tria',
        },
        profile4: {
          name: 'Nathalène Chapuis',
          excerpt: 'Description to come',
          body:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore',
          contact: 'Communiquez avec Mr "To Come"',
        },
      },
      teamNextPageLinkToNextPage: 'Useful Resources',
    },
    resourcesTranslate: {
      resourcesEntryTitle: 'Useful Resources',
      resourcesGlossaryTitle: 'A - Z',
      resourcesGlossaryLinks1: 'Useful Resource 1',
      resourcesGlossaryLinks2: 'Useful Resource 2',
      resourcesGlossaryLinks3: 'Useful Resource 3',
      resourcesGlossaryLinks4: 'Useful Resource 4',
      resourcesGlossaryLinks5: 'Useful Resource 5',
      resourcesGlossaryLinks6: 'Useful Resource 6',
      resourcesGlossaryLinks7: 'Useful Resource 7',
      resourcesGlossaryLinks8: 'Useful Resource 8',
      resourcesGlossaryLinks9: 'Useful Resource 9',
      resourcesGlossaryLinks10: 'Useful Resource 10',
      resourcesGlossaryLinks11: 'Useful Resource 11',
      resourcesGlossaryLinks12: 'Useful Resource 12',
      resourcesGlossaryLinks13: 'Useful Resource 13',
      resourcesGlossaryLinks14: 'Useful Resource 14',
      resourcesNextPageLinkToNextPage: 'FAQ',
    },
    faqTranslate: {
      faqEntryTitle: 'FAQ',
      faqQuestions: {
        question1: {
          question:
            'What should we bring during our first appointment at the notary?',
          answer:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto ab, dolores esse ut perspiciatis neque quidem porro fugiat odit veniam.',
        },
        question2: {
          question:
            'What should we bring during our first appointment at the notary?',
          answer:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto ab, dolores esse ut perspiciatis neque quidem porro fugiat odit veniam.',
        },
        question3: {
          question:
            'What should we bring during our first appointment at the notary?',
          answer:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto ab, dolores esse ut perspiciatis neque quidem porro fugiat odit veniam.',
        },
        question4: {
          question:
            'What should we bring during our first appointment at the notary?',
          answer:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto ab, dolores esse ut perspiciatis neque quidem porro fugiat odit veniam.',
        },
        question5: {
          question:
            'What should we bring during our first appointment at the notary?',
          answer:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto ab, dolores esse ut perspiciatis neque quidem porro fugiat odit veniam.',
        },
        question6: {
          question:
            'What should we bring during our first appointment at the notary?',
          answer:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto ab, dolores esse ut perspiciatis neque quidem porro fugiat odit veniam.',
        },
      },
      faqNextPageLinkToNextPage: 'Contact',
    },
    contactTranslate: {
      contactBody: {
        title: 'Contact',
        profile1: {
          name: 'Louise Giguère',
          phone: '514-279-8977',
          email: 'notaire@lgiguere.com',
        },
        profile2: {
          name: 'Louis-Philippe Léveillé',
          phone: 'To come',
          email: 'To come',
        },
        profile3: {
          name: 'Selma Tria',
          phone: 'To come',
          email: 'To come',
        },
        profile4: {
          name: 'Nathalène Chapuis',
          phone: 'To come',
          email: 'To come',
        },
      },
      contactForm: {
        firstname: 'First name',
        lastname: 'Last name',
        phone: 'Phone',
        email: 'Email',
        message: 'How can we help?',
        messageCheckbox: 'I have read, and accept the conditions',
        terms: 'Read conditions',
        messageToAccept:
          'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto ab, dolores esse ut perspiciatis neque quidem porro fugiat odit veniam. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto ab, dolores esse ut perspiciatis neque quidem porro fugiat odit veniam.',
      },
    },
    footer: {
      privacy_banner: {
        body_text:
          'Responsable de la protection des renseignements personnels : ',
        privacy_text:
          'Lien vers notre politique de confidentialité des renseignements personnels',
      },
      address: '24, avenue de l’Épée, Montréal (Outremont), Qc, H2V 3S9;',
      address_specifications:
        'Situé au rez-de-chaussée et facilite l’accès aux handicapés',
      phone_text: '(514) 279-8977',
      phone_link: 'tel:+15142798977',
      fax_text: '(514) 273-0108',
      email: 'Écrivez-nous',
      hours_text: "Heures d'ouverture",
      hours_specifications:
        'Veuillez prendre note que nos bureaux sont fermés entre 12h00 et 13h00 tous les jours.',
      hours: {
        monday: 'L',
        monday_hours: '9-6',
        tuesday: 'M',
        tuesday_hours: '9-6',
        wednesday: 'M',
        wednesday_hours: '9-6',
        thursday: 'J',
        thursday_hours: '9-6',
        friday: 'V',
        friday_hours: '9-12',
        saturday: 'S',
        saturday_hours: 'Fermé',
        sunday: 'D',
        sunday_hours: 'Fermé',
      },
    },
  },
  fr: {
    navigationTranslate: {
      home: 'Accueil',
      about: 'À propos',
      services: 'Services',
      team: 'Équipe',
      faq: 'FAQ',
      resources: 'Liens utiles',
      contact: 'Nous contacter',
    },
    homeTranslate: {
      lang: 'Langage',
      homeEntryTitle: 'Le souci du détail',
      homeEntrySubtitle: 'Depuis plus de 35 ans',
      homeAboutTitle: 'Votre Bureau Familial',
      homeAboutBody: 'Notaires de famille de mère en fils.',
      homeAboutRouterLink: 'Lire davantage',
      homeEmployeeHighlightTitle:
        'C’est avec grand plaisir que nous vous informons de la venue de Maître Nathalène Chapuis au sein de notre équipe.',
      homeEmployeeHighlightBody:
        'Me Nathalène Chapuis, originaire de France, est issue d’une famille de notaires dont les premiers actes ont été reçus au 17 ème siècle par son ancêtre, Maître Cirgue Segret. Elle s’est donc naturellement orientée vers cette profession et elle obtient, en 2000, le Diplôme Supérieur du Notariat en France. Me Chapuis travaille ensuite dans deux Études notariales en France puis dans un cabinet d’avocats à Chicago avant de s’installer au Québec où elle obtient en 2006 le Diplôme de Droit Notarial. Compte tenu de sa double diplomation notariale franco-québécoise, elle s’est progressivement spécialisée auprès d’une clientèle internationale, et notamment française, dont les besoins juridiques impliquent une connaissance poussée en droit international privé. Elle a également développé, de façon plus générale, une expertise en droit successoral et droit matrimonial. Elle s’est vu confier par la Chambre des Notaires du Québec la formation en droit international privé des notaires du très prisé service 1-800-NOTAIRE. Elle participe régulièrement à des évènements auprès d’étudiants en droit du Québec à titre d’ambassadrice de la Chambre des Notaires du Québec. Maître Chapuis a également reçu à Québec le 15 mars 2019 la Convention De Coopération Entre Les Notaires De France et Du Québec signée par le Conseil supérieur du notariat (France) et la Chambre des notaires du Québec en présence de la consule générale de France. Cette convention de coopération notariale de 2019 a pour but de favoriser la coopération entre les notaires de France et du Québec au bénéfice des citoyens.',
      homeEmployeeHighlightBodySecondary:
        'Outre les nombreuses conférences auxquelles elle participe depuis plusieurs années auprès de banquiers, de planificateurs financiers et d’associations franco-canadiennes telle que l’Union de Français à l’Étranger de Montréal, Maître Chapuis a donné, en octobre 2019, une conférence auprès des notaires sur les aspects civils d’une planification patrimoniale transfrontalière. Elle travaille en étroite collaboration avec un important réseau de juristes en Europe et au Canada. Maître Chapuis privilégie toujours un travail d’équipe avec tous les professionnels impliqués au dossier.',
      homeEmployeeHighlightRouterLink: 'Lire davantage',
      homeServicesTitle:
        'Présent lors des moments les plus marquants de votre vie',
      homeServicesSubtitle:
        'Nous offrons une gamme complète de services selon vos besoins',
      homeServicesService1: 'Immobilier',
      homeServicesService2: 'Droit de la copropriété',
      homeServicesService3: 'Libéralités',
      homeServicesService4:
        'Procédures non-contentieuses devant notaire ou devant tribunal',
      homeServicesService5: 'Succession',
      homeServicesService6: 'Droit de la famille',
      homeServicesRouterLink: 'Lire davantage',
      homeTeamTitle: 'Notre famille',
      homeTeamProfileLink: 'Voir le profil',
      homeTeamProfilesLink: 'Lire davantage',
      homeTeamProfile1: {
        name: 'Louise Giguère',
        title: 'Notaire retraitée (fondatrice)',
      },
      homeTeamProfile2: {
        name: 'Louis-Philippe Léveillé',
        title: 'Notaire (associé)',
      },
      homeTeamProfile3: {
        name: 'Selma Tria',
        title: 'Notaire (associée)',
      },
      homeTeamProfile4: {
        name: 'Nathalène Chapuis',
        title: 'Notaire',
      },
      motto: 'Compétence, Intégrité, Fiabilité',
    },
    aboutTranslate: {
      aboutEntryTitle: 'À propos',
      aboutEntrySubtitle:
        'Située au cœur d’Outremont depuis plus de 35 ans, GIGUÈRE, LÉVEILLÉ, TRIA, NOTAIRES est une entreprise familiale initialement fondée par Me Louise Giguère, notaire. Pratiquant d’abord seule, cette dernière bâtit la bonne réputation de l’étude basée sur ses valeurs de rigueur et de professionnalisme. Offrant une gamme de services reliés à la pratique générale, Me Giguère développa au fil du temps son expertise dans le domaine de la copropriété, plus particulièrement celui de l’indivision et des conversions divises.',
      aboutEntrySubtitleSecond:
        'Ces dernières années, Me Selma Tria, notaire et Me Louis-Philippe Léveillé, notaire et fils de Me Giguère, se joignent à l’étude y apportant un vent de jeunesse. Ces derniers bénéficient alors du savoir et de l’expertise transmis par la fondatrice, ce qui leur permet de développer leur pratique basée sur les mêmes vertus. Aujourd’hui, c’est toute l’équipe de GIGUÈRE, LÉVEILLÉ, TRIA, NOTAIRES qui exerce les activités de la société avec rigueur et professionnalisme tout en gardant constamment à jour leurs connaissances.',
      aboutEntryAnchorToFirstSection: 'Histoire',
      aboutEntryAnchorToSecondSection: 'Mission',
      aboutHistoryTitle: 'Notre Mission',
      aboutHistorySubtitle: '35 ans d’expertise',
      aboutHistoryBody:
        'En tant qu’entreprise familiale, notre mission est d’offrir à nos clients et partenaires un service de proximité basé sur un lien de confiance qui perdure de génération en génération. Compétence, intégrité et fiabilité sont nos valeurs nous permettant de remplir cette mission.',
      aboutNextPageLinkToNextPage: 'Consultez nos services',
    },
    servicesTranslate: {
      servicesEntryTitle: 'Nos services',
      servicesEntryAnchorToService1: 'Immobilier',
      servicesEntryAnchorToService2: 'Droit de la copropriété',
      servicesEntryAnchorToService3: 'Libéralités',
      servicesEntryAnchorToService4:
        'Procédures non-contentieuses devant notaire ou devant tribunal',
      servicesEntryAnchorToService5: 'Succession',
      servicesEntryAnchorToService6: 'Droit de la famille',
      servicesService1: {
        title: 'Immobilier',
        subtitle: 'La sécurité avant tout.',
        linkDesktop: 'Renseignez-vous auprès de nos notaires',
        step1: {
          title: 'Déclaration de transmission.',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step2: {
          title: 'Promesse d’achat',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step3: {
          title: 'Financement immobilier résidentiel et commercial',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step4: {
          title: 'Acquisition et vente d’immeuble',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step5: {
          title: 'Hypothèque mobilière',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step6: {
          title: 'Servitude',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step7: {
          title: 'Quittance',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step8: {
          title: 'Acte de donation',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
      },
      servicesService2: {
        title: 'Droit de la Copropriété',
        subtitle: 'Pionniers en la matière',
        linkDesktop: 'Renseignez-vous auprès de nos notaires',
        step1: {
          title: 'Convention d’indivision',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step2: {
          title: 'Déclaration de copropriété divise',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step3: {
          title: 'Amendements',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
      },
      servicesService3: {
        title: 'Libéralités',
        subtitle: 'Protéger ce qu’il y a de plus cher',
        linkDesktop: 'Renseignez-vous auprès de nos notaires',
        step1: {
          title: 'Testaments',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step2: {
          title: 'Procuration générale et mandat de protection',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step3: {
          title: 'Directives médicales anticipées',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
      },
      servicesService4: {
        title: 'Procédures non-contentieuses devant notaire ou devant tribunal',
        subtitle: 'Mieux vous accompagner',
        linkDesktop: 'Renseignez-vous auprès de nos notaires',
        step1: {
          title: 'Homologation de mandat de protection',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step2: {
          title: 'Vérification de testament olographe et devant témoins',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step3: {
          title: 'Ouverture de régime de protection',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step4: {
          title: 'Tutelle au mineur',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
      },
      servicesService5: {
        title: 'Succession',
        subtitle: 'Laissez nous vous guider',
        linkDesktop: 'Renseignez-vous auprès de nos notaires',
        step1: {
          title: 'Recherche testamentaire',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step2: {
          title: 'Bilan patrimonial',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step3: {
          title: 'Déclaration de transmission',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step4: {
          title: 'Procès-verbal d’ouverture de coffret de sûreté',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
      },
      servicesService6: {
        title: 'Droit de la famille',
        subtitle: 'Pour rester tissés serrés',
        linkDesktop: 'Renseignez-vous auprès de nos notaires',
        step1: {
          title: 'Célébration de mariage',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step2: {
          title: 'Contrat de mariage',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step3: {
          title: 'Convention de conjoints de fait',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
        step4: {
          title: 'Divorce à l’amiable',
          excerpt:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt',
          link: 'Cliquer pour dérouler la suite',
          linkContentBody:
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore Lorem ipsum dolor sit amet.',
        },
      },
      servicesNextPageLinkToNextPage: 'Notre équipe',
    },
    teamTranslate: {
      teamEntryTitle: 'Notre équipe',
      teamEntryAnchorToTeamMember1: 'Louise Giguère',
      teamEntryAnchorToTeamMember2: 'Louis-Philippe Léveillé',
      teamEntryAnchorToTeamMember3: 'Selma Tria',
      teamEntryAnchorToTeamMember4: 'Nathalène Chapuis',
      teamProfiles: {
        profile1: {
          name: 'Louise Giguère',
          excerpt: 'Notaire fondatrice à la retraite',
          body:
            "Avant de faire ses études en droit et d'obtenir son diplôme de droit notarial, Me Giguère poursuivait une carrière de graphiste au sein de l'Institut de tourisme et d'hôtellerie du Québec. À la suite d'une carrière notariale de près de 40 ans, Me Giguère est désormais à la retraite et profite d'un repos bien mérité.",
          contact: '',
        },
        profile2: {
          name: 'Louis-Philippe Léveillé',
          excerpt: 'Notaire associé et amateur de course automobile',
          body:
            'Détenteur d’une maîtrise en droit notarial, Me Léveillé est aussi détenteur d’une majeure en science politique de l’Université de Montréal. Lorsqu’il n’est pas au bureau, vous le retrouverez sur les pentes de ski ou sur un parcours de golf, ses terrains de jeux favoris.<br><br>L’aspect qu’il privilégie dans sa pratique : l’écoute attentive de ses clients.',
          contact: 'Communiquez avec Me Léveillé',
        },
        profile3: {
          name: 'Selma Tria',
          excerpt: 'Notaire associée et mordue de la gastronomie',
          body:
            'Mis à part son diplôme de droit notarial, Me Tria possède également un certificat en criminologie de l’Université de Montréal. Lorsqu’elle n’est pas au bureau ou en train de concocter une nouvelle recette culinaire, vous la retrouverez en plein cœur d’un parc national ou en pleine session de yoga.<br><br>L’aspect qu’elle privilégie dans sa pratique : le devoir de conseil.',
          contact: 'Communiquez avec Me Tria',
        },
        profile4: {
          name: 'Nathalène Chapuis',
          excerpt: 'Notaire et amatrice de design',
          body:
            'Détentrice du diplôme de notaire au Québec, Me Chapuis était initialement détentrice d’un diplôme de notaire en France. Lorsqu’elle n’est pas au bureau ou en train de se promener à pied ou en vélo dans la ville, vous la retrouverez probablement dans un aéroport. L’aspect qu’elle privilégie dans sa pratique : la recherche de solutions juridiques efficaces. ',
          contact: 'Communiquez avec Me Chapuis',
        },
      },
      teamNextPageLinkToNextPage: 'Liens utiles',
    },
    resourcesTranslate: {
      resourcesEntryTitle: 'Liens utiles',
      resourcesGlossaryTitle: 'A - Z',
      resourcesGlossaryLinks1: 'Chambre des notaires du Québec',
      resourcesGlossaryLinks2: 'Tout savoir sur la copropriété',
      resourcesGlossaryLinks3: 'Régie du logement',
      resourcesGlossaryLinks5: 'Registre foncier',
      resourcesGlossaryLinks6:
        'Registre des droits personnels et réels mobiliers',
      resourcesGlossaryLinks7: 'Lien utile 7',
      resourcesGlossaryLinks8: 'Lien utile 8',
      resourcesGlossaryLinks9: 'Lien utile 9',
      resourcesGlossaryLinks10: 'Lien utile 10',
      resourcesGlossaryLinks11: 'Lien utile 11',
      resourcesGlossaryLinks12: 'Lien utile 12',
      resourcesGlossaryLinks13: 'Lien utile 13',
      resourcesGlossaryLinks14: 'Lien utile 14',
      resourcesNextPageLinkToNextPage: 'FAQ',
    },
    faqTranslate: {
      faqEntryTitle: 'FAQ',
      faqQuestions: {
        question1: {
          question:
            'Que doit-on apporter lors de notre premier rendez-vous chez le notaire?',
          answer:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto ab, dolores esse ut perspiciatis neque quidem porro fugiat odit veniam.',
        },
        question2: {
          question:
            'Que doit-on apporter lors de notre premier rendez-vous chez le notaire?',
          answer:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto ab, dolores esse ut perspiciatis neque quidem porro fugiat odit veniam.',
        },
        question3: {
          question:
            'Que doit-on apporter lors de notre premier rendez-vous chez le notaire?',
          answer:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto ab, dolores esse ut perspiciatis neque quidem porro fugiat odit veniam.',
        },
        question4: {
          question:
            'Que doit-on apporter lors de notre premier rendez-vous chez le notaire?',
          answer:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto ab, dolores esse ut perspiciatis neque quidem porro fugiat odit veniam.',
        },
        question5: {
          question:
            'Que doit-on apporter lors de notre premier rendez-vous chez le notaire?',
          answer:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto ab, dolores esse ut perspiciatis neque quidem porro fugiat odit veniam.',
        },
        question6: {
          question:
            'Que doit-on apporter lors de notre premier rendez-vous chez le notaire?',
          answer:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto ab, dolores esse ut perspiciatis neque quidem porro fugiat odit veniam.',
        },
      },
      faqNextPageLinkToNextPage: 'Contact',
    },
    contactTranslate: {
      contactBody: {
        title: 'Contact',
        profile1: {
          name: '',
          phone: '514-279-8977',
          email: 'reception@lgiguere.com',
        },
        profile2: {
          name: 'Louis-Philippe Léveillé',
          phone: 'À venir',
          email: 'À venir',
        },
        profile3: {
          name: 'Selma Tria',
          phone: 'À venir',
          email: 'À venir',
        },
        profile4: {
          name: 'Nathalène Chapuis',
          phone: 'À venir',
          email: 'À venir',
        },
      },
      contactForm: {
        firstname: 'Prénom',
        lastname: 'Nom',
        phone: 'Téléphone',
        email: 'Courriel',
        message: 'Comment pouvons-nous vous aider?',
        messageCheckbox: "J'ai lu et j'accepte les conditions",
        terms: 'Lire les conditions',
        messageToAccept:
          'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto ab, dolores esse ut perspiciatis neque quidem porro fugiat odit veniam. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto ab, dolores esse ut perspiciatis neque quidem porro fugiat odit veniam.',
      },
    },
    footer: {
      privacy_banner: {
        body_text:
          'Responsable de la protection des renseignements personnels : ',
        privacy_text:
          'Lien vers notre politique de confidentialité des renseignements personnels',
      },
      address: '24, avenue de l’Épée, Montréal (Outremont), Qc, H2V 3S9;',
      address_specifications:
        'Situé au rez-de-chaussée et facilite l’accès aux handicapés',
      phone_text: '(514) 279-8977',
      phone_link: 'tel:+15142798977',
      fax_text: '(514) 273-0108',
      email: 'Écrivez-nous',
      hours_text: "Heures d'ouverture",
      hours_specifications:
        'Veuillez prendre note que nos bureaux sont fermés entre 12h00 et 13h00 tous les jours.',
      hours: {
        monday: 'L',
        monday_hours: '9-6',
        tuesday: 'M',
        tuesday_hours: '9-6',
        wednesday: 'M',
        wednesday_hours: '9-6',
        thursday: 'J',
        thursday_hours: '9-6',
        friday: 'V',
        friday_hours: '9-12',
        saturday: 'S',
        saturday_hours: 'Fermé',
        sunday: 'D',
        sunday_hours: 'Fermé',
      },
    },
  },
};

export default translations
